import React from 'react';
import { Box, Typography } from '@mui/material';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import WidgetCard from './WidgetCard';

const ACCENT = '#db2777';

/** Виджет «Акции» - пока заглушка, источник данных будет подключен позже. Право: home.promotions.view */
const PromotionsWidget: React.FC = () => (
  <WidgetCard title="Акции" icon={<LocalOfferOutlinedIcon />} accent={ACCENT}>
    <Box
      sx={{
        height: '100%', minHeight: 120, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 0.5, p: 2, textAlign: 'center'
      }}
    >
      <LocalOfferOutlinedIcon sx={{ fontSize: 30, color: '#f9a8d4' }} />
      <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#475569' }}>Акций пока нет</Typography>
      <Typography sx={{ fontSize: 12.5, color: '#94a3b8' }}>Здесь появятся действующие акции</Typography>
    </Box>
  </WidgetCard>
);

export default PromotionsWidget;
